var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconManColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.548 14.286a2.381 2.381 0 11-4.762 0 2.381 2.381 0 014.762 0m16.666 0a2.381 2.381 0 11-4.762 0 2.381 2.381 0 014.762 0",
    fill: "#FFA726"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB74D",
    d: "M3.571 10.119c0-7.574 17.858-4.93 17.858 0v5.952a8.929 8.929 0 01-17.858 0V10.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M22.554 9.725c-.282-3.555-1.524-7.057-5.887-7.94L15.477 0H12.5C7.007 0 2.381 4.452 2.381 10.714v2.024l1.786 2.143V11.31l12.5-4.167 4.166 3.571v4.167l1.786-2.143v-2.024a8.21 8.21 0 00-.065-.989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.857 14.881a1.19 1.19 0 11-2.38 0 1.19 1.19 0 012.38 0m-8.333 0a1.19 1.19 0 11-2.38 0 1.19 1.19 0 012.38 0",
    fill: "#784719"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FB8C00",
    d: "M9.524 20.238h5.952s-1.19 1.786-2.976 1.786-2.976-1.786-2.976-1.786z"
  }))));
}

export default SvgCommonIconManColor;